import { useContext, useEffect, useState } from 'react';
import { Grid2 as Grid, Avatar, Typography, Stack, Dialog, DialogTitle, IconButton, DialogContent, useMediaQuery } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { blue } from '@mui/material/colors';
import { Close, Article } from '@mui/icons-material';
import FilerDocument from '../../../../types/filers/filerDocument';
import FilerAuditLetter from '../../../../types/filers/filerAuditLetter';
import FilerAuditResponse from '../../../../types/filers/filerAuditResponse';
import { FilersDataContext } from '../../Filers';

interface DocumentViewerProps {
  isDocumentViewerOpen: boolean;
  closeDocumentViewer: () => void;
  document?: FilerDocument;
  letter? :FilerAuditLetter;
  response?: FilerAuditResponse;
}

const DocumentViewer = (props: DocumentViewerProps): JSX.Element => {


    const filerDataContext = useContext(FilersDataContext);
    const currentFiler = filerDataContext.currentFilerPayload?.filer;

    const theme = useTheme();

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
      });

    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const frameHeight = '800px';

    const [filerName, setFilerName] = useState(`${currentFiler?.cpfId} ${currentFiler?.fullName}`);
    const [documentDescription, setDocumentDescription] = useState('');
    const [documentLink, setDocumentLink] = useState('');

    useEffect(() => {
        if (props.document) {
            setDocumentDescription(`${props.document.documentTypePublicDescription} ${props.document.documentDateDisplay}`);
            setDocumentLink(props.document.extranetBlobUrl);
        }

        if (props.letter) {
            setDocumentDescription(`${props.letter.letterType} ${props.letter.dateSentDisplay}`);
            setDocumentLink(props.letter.blobUrl);
        }

        if (props.response) {
            setDocumentDescription(props.response.responseFormat);
            setDocumentLink(props.response.blobUrl);
        }

    },[props.document, props.letter, props.response]);

    return (
        <>
        {
                (props.document || props.letter || props.response) &&
                <Dialog
                    open={props.isDocumentViewerOpen}
                    scroll={'paper'}
                    fullScreen={fullScreen}
                    fullWidth={true}
                    maxWidth={'md'}
                    keepMounted
                    onClose={props.closeDocumentViewer}
                    sx={{
                        "& .MuiDialog-container": {
                            justifyContent: "flex-end",
                            alignItems: "flex-end"
                        }
                    }}
                    PaperProps={{
                        sx: {
                            m: 0,
                            top: 0,
                            right: 0,
                            bottom: 0,
                            minHeight: isMd? '100vh': '90vh'
                        }
                    }}
                >
                    <DialogTitle>
                        <Stack direction="row" spacing={2} alignItems="center">
                            <Avatar sx={{ bgcolor: blue[500] }}><Article /></Avatar>
                            <Typography variant="subtitle1" sx={{ color: blue[800] }}>
                                {filerName}:
                            </Typography>
                            <Typography variant="subtitle1" sx={{ color: blue[800] }}>
                                {documentDescription}
                            </Typography>
                        </Stack>
                    </DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={props.closeDocumentViewer}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <Close />
                    </IconButton>
                    <DialogContent dividers>
                        <iframe src={documentLink} width="99%" height={frameHeight} />
                    </DialogContent>
                </Dialog>
            }
        </>
    );
  };

export default DocumentViewer;